import React from 'react';

export default () => (
  <svg x="0" y="0" width="100" height="100" viewBox="0, 0, 100, 100">
    <g id="Layer_1">
      <g id="Layer_1">
        <path d="M0,74.766 L23.43,74.766 L23.43,24.224 L0,2.426 z" fill="#FEFEFE" />
        <path d="M2.615,0 L26.068,21.795 L71.594,21.795 L71.594,12.891 L57.724,0 z" fill="#FEFEFE" />
        <path d="M75.288,23.515 L75.288,61.626 L93.258,78.504 L98.718,83.63 L98.718,38.133 L75.291,16.135 z" fill="#FEFEFE" />
        <path d="M25.279,78.202 L2.612,78.202 L26.042,100 L81.154,100 L57.724,78.202 z" fill="#FEFEFE" />
        <path d="M61.084,76.476 L73.296,87.835 L85.607,99.287 L97.959,87.797 L73.447,64.78 z" fill="#FEFEFE" />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/header/logo.js